import React from 'react'
import { GatsbyImage } from "gatsby-plugin-image";
import * as styles from './index.module.css'
import { GradientBorder } from '../commons'
import Button from '../Button/'

const CareerAboutUs = ({ title, subtitle, components }) => {
  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <h2>{title}</h2>
      </div>
      <div className={`${styles.section} ${styles.list}`}>
        {components.map((comp, idx) => (
          <div key={idx}>
            <div className={`${styles.compTitle} h2`}>{comp.title}</div>
            <div className={styles.description}>{comp.subtitle.subtitle}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default CareerAboutUs
